import { gql } from '@urql/core';

export const GET_TESTIMONIALS = gql`
  query GetTestimonials($options: TestimonialListOptions) {
    testimonials(options: $options) {
      items {
        id
        createdAt
        customerName
        customerEmail
        rating
        text
        state
        source
        rejectionReason
      }
      totalItems
    }
  }
`;

export const GET_TESTIMONIAL_SETTINGS = gql`
  query GetTestimonialSettings {
    testimonialSettings {
      id
      enabled
      acceptLinkSubmissions
    }
  }
`;

export const REJECT_TESTIMONIAL = gql`
  mutation RejectTestimonial($id: ID!, $reason: String) {
    rejectTestimonial(id: $id, reason: $reason) {
      success
      errorCode
      testimonial {
        id
        state
        rejectionReason
      }
    }
  }
`;

export const DELETE_TESTIMONIAL = gql`
  mutation DeleteTestimonial($id: ID!) {
    deleteTestimonial(id: $id) {
      success
      errorCode
    }
  }
`;

export const DISABLE_TESTIMONIAL_COLLECTION = gql`
  mutation DisableTestimonialCollection($input: UpdateTestimonialSettingsInput!) {
    updateTestimonialSettings(input: $input) {
      id
      enabled
      acceptLinkSubmissions
    }
  }
`;
